export const environment = {
  production: false, // This should be false for development
  apiHost: 'https://nasij-api.kortobaa.net/',
  // ForceAdminOtpLogin: true,
  firebase: {
    apiKey: 'AIzaSyCCvn_zx-_JHeLBLkz49_RGSq2WAi0aRhY',
    authDomain: 'nasij-dev.firebaseapp.com',
    projectId: 'nasij-dev',
    storageBucket: 'nasij-dev.firebasestorage.app',
    messagingSenderId: '431307340023',
    appId: '1:431307340023:web:e67776627106f6fb6cfbf2',
    measurementId: 'G-Y5QF9L1HE3',
    vapidKey:
      'BPGLwdXXibuZxTpaeENo8coTwFcd-Y3NirEoxBK3e4Jve7l_XE1LlLs5T5E5Tk5fXZLkw6kJob14hM4MaBFJrAQ',
  },
  vendureAPI: 'https://nasij-vendure.kortobaa.net/admin-api',
  vendureVariables: {
    username: 'superadmin',
    password: 'superadmin',
    rememberMe: true,
  },
};
